<template>
  <div>
    <main-header />
    <div class="daily-cargo-edit-identity-check-sheet">
      <div class="daily-cargo-edit-identity-check-sheet__references" />
      <div class="daily-cargo-edit-identity-check-sheet__dgr_references">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>Tour</form-label>
          <div>
            {{ dailyCargoDriverData.Flight_Name }}
          </div>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>Transport company</form-label>
          <div>
            {{ dailyCargoDriverData.Transporter }}
          </div>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>License company</form-label>
          <div>
            {{ dailyCargoDriverData.License_Number }}
          </div>
        </div>
        <div style="grid-column: 4; grid-row: 1;">
          <form-label>Providers</form-label>
          <form-filtered-select
            v-model="dailyCargoDriverData.Provider_ID"
            :options="activeProviderOptions"
            :selected-key="dailyCargoDriverData.Provider_ID"
            placeholder="Provider" />
        </div>
        <div style="grid-column: 5; grid-row: 1;">
          <form-label>Driver</form-label>
          <form-filtered-select
            v-model="dailyCargoDriverData.Driver_ID"
            :options="driverOptions"
            :selected-key="dailyCargoDriverData.Driver_ID"
            track-by="Driver_ID"
            label="Driver_Name"
            data-cy="daily-cargo-edit-identity-check-sheet-driver"
            placeholder="Driver"
            @updateDropdownValue="onUpdateValue" />
          <span v-if="$v.dailyCargoDriverData.Driver_Name && $v.dailyCargoDriverData.Driver_Name.$invalid" class="error">Please select a Driver</span>
        </div>
        <div style="grid-column: 6; grid-row: 1;">
          <form-label>License Plate</form-label>
          <form-input
            v-model="dailyCargoDriverData.Plate_Number"
            :invalid="$v.dailyCargoDriverData.Plate_Number && $v.dailyCargoDriverData.Plate_Number.$invalid"
            placeholder="License Plate"
            data-cy="edit-daily-cargo-plate-number" />
          <span v-if="$v.dailyCargoDriverData.Plate_Number && !$v.dailyCargoDriverData.Plate_Number.$invalid" class="error">Please enter a plate number</span>
        </div>
        <div style="grid-column: 7; grid-row: 1;">
          <form-label>Vehicle Type</form-label>
          <form-filtered-select
            v-model="dailyCargoDriverData.Vehicle_ID"
            :options="vehicleOptions"
            :selected-key="dailyCargoDriverData.Vehicle_ID"
            placeholder="Vehicle" />
        </div>
        <div style="grid-column: 8; grid-row: 1;">
          <form-label>Pre Carriage Route</form-label>
          <form-filtered-select
            v-model="dailyCargoDriverData.PreCarriage_Route_ID"
            :options="preCarriageRouteOptions"
            :selected-key="dailyCargoDriverData.PreCarriage_Route_ID"
            placeholder="PreCarriage Route" />
        </div>
      </div>
      <div class="daily-cargo-edit-identity-check-sheet__dgr_nr_of_pieces">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>Seal Number 1</form-label>
          <form-input
            v-model="dailyCargoDriverData.Seal_Number_1"
            :invalid="$v.dailyCargoDriverData.Seal_Number_1 && $v.dailyCargoDriverData.Seal_Number_1.$invalid"
            placeholder="Seal Number 1"
            data-cy="edit-daily-cargo-seal-number-1" />
          <span v-if="$v.dailyCargoDriverData.Seal_Number_1 && !$v.dailyCargoDriverData.Seal_Number_1.$invalid" class="error">Please enter a seal number</span>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>Seal Number 2</form-label>
          <form-input
            v-model="dailyCargoDriverData.Seal_Number_2"
            :invalid="$v.dailyCargoDriverData.Seal_Number_2 && $v.dailyCargoDriverData.Seal_Number_2.$invalid"
            placeholder="Seal Number 2"
            data-cy="edit-daily-cargo-seal-number-2" />
          <span v-if="$v.dailyCargoDriverData.Seal_Number_2 && !$v.dailyCargoDriverData.Seal_Number_2.$invalid" class="error">Please enter a seal number</span>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>Seal Number 3</form-label>
          <form-input
            v-model="dailyCargoDriverData.Seal_Number_3"
            placeholder="Seal Number 3"
            data-cy="edit-daily-cargo-seal-number-3" />
        </div>
      </div>
      <div v-if="dailyCargoDriverData.Flight_ID === constants.FLIGHT_ID.FKB_JKG" class="daily-cargo-edit-identity-check-sheet__dgr_nr_of_pieces">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>Nr Of Pieces DK</form-label>
          <form-input
            v-model="dailyCargoDriverData.Nr_Of_Pieces_DK"
            placeholder="Nr Of Pieces DK"
            data-cy="edit-daily-cargo-nr-of-pieces-dk" />
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>Nr Of Pieces NO</form-label>
          <form-input
            v-model="dailyCargoDriverData.Nr_Of_Pieces_NO"
            placeholder="Nr Of Pieces NO"
            data-cy="edit-daily-cargo-nr-of-pieces-no" />
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>Nr Of Pieces FI</form-label>
          <form-input
            v-model="dailyCargoDriverData.Nr_Of_Pieces_FI"
            placeholder="Nr Of Pieces FI"
            data-cy="edit-daily-cargo-nr-of-pieces-fi" />
        </div>
        <div style="grid-column: 4; grid-row: 1;">
          <form-label>Nr Of Pieces SE</form-label>
          <form-input
            v-model="dailyCargoDriverData.Nr_Of_Pieces_SE"
            placeholder="Nr Of Pieces SE"
            data-cy="edit-daily-cargo-nr-of-pieces-se" />
        </div>
      </div>
      <div v-if="dailyCargoDriverData.Flight_ID !== constants.FLIGHT_ID.FKB_JKG" class="daily-cargo-edit-identity-check-sheet__dgr_nr_of_pieces">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>Nr of Pieces MHG</form-label>
          <form-input
            v-model="dailyCargoDriverData.Nr_Of_Pieces_MHG"
            placeholder="Nr of Pieces MHG"
            data-cy="edit-daily-cargo-nr-of-pieces" />
        </div>
      </div>
    </div>
    <daily-cargo-edit-action-bar
      :invalid="$v.$invalid"
      @onSave="handleSave"
      @onCancel="handleCancel" />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import MessageDialog from '@/components/shared/message-dialog'
import { create } from 'vue-modal-dialogs'
import Helpers from '@/helpers.vue'
import { minValue, required } from 'vuelidate/lib/validators'
import constants from '@/constants'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      routeLabel: '',
      dailyCargoDriverData: {},
      driverOptions: {},
      constants
    }
  },
  validations () {
    return {
      dailyCargoDriverData: {
        ...this.validatedFields
      }
    }
  },
  created () {
    this.dailyCargoDriverData = this.$route.params
    this.driverOptions = this.dailyCargoDriver
  },
  computed: {
    ...mapState('dailyCargo', ['dailyCargoDriver']),
    ...mapGetters('provider', ['activeProviderOptions']),
    ...mapGetters('vehicle', ['vehicleOptions']),
    ...mapGetters('preCarriageRoutes', ['preCarriageRouteOptions']),
    validatedFields () {
      var fields = {}
      if (!this.dailyCargoDriverData.Driver_Name) {
        fields.Driver_Name = { required, minValue: minValue(0) }
      }
      if (!this.dailyCargoDriverData.Plate_Number) {
        fields.Plate_Number = { required }
      }
      if (!this.dailyCargoDriverData.Seal_Number_1) {
        fields.Seal_Number_1 = { required }
      }
      if (!this.dailyCargoDriverData.Seal_Number_2) {
        fields.Seal_Number_2 = { required }
      }
      return fields
    }
  },
  methods: {
    ...mapActions('dailyCargo', ['saveDailyCargoSealNumber']),
    getRouteLabel (flightId) {
      return this.routeOptions.filter(route => route.value === flightId)[0].label
    },
    onUpdateValue (value) {
      this.dailyCargoDriverData.Driver_ID = value.Driver_ID
      this.dailyCargoDriverData.Transporter = value.Transporter
      this.dailyCargoDriverData.License_Number = value.License_Number
    },
    validateAndSend () {
      this.isLoading = true
      this.saveDailyCargoSealNumber(this.dailyCargoDriverData).then((response) => {
        this.isLoading = false
        this.$router.push('/daily-cargo-general/5')
        this.$forceUpdate()
      }).catch((error) => {
        this.isLoading = false
        messageDialog('Something went wrong: ' + error.ExceptionMessage)
      })
    },
    // *********************** Handle Actionbar *************************
    handleSave () {
      this.validateAndSend()
    },
    handleCancel () {
      this.$router.push('/daily-cargo-general/5')
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';
  .daily-cargo-edit-identity-check-sheet {
    margin-bottom: 100px;
    margin: 0 70px;
    width: calc(100% - 138px);
    &__date {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;

      &--active {
        background-color: $grey_80 !important;
      }

    }

    &__dgr_references {
      display: grid;
      grid-template-columns: 5% 13% 13% 13% 13% 13% 13% 13%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 50px;
    }
    &__dgr_nr_of_pieces {
      display: grid;
      grid-template-columns: 13% 13% 13% 13% 13% 13%;
      grid-gap: 7px;
      width: 100%;
    }
    &__dgr_references:last-child {
      padding-bottom: 100px;
      padding-top: 50px;
    }
  }
</style>
